import * as React from 'react';

import { makeStyles } from '@egr/xbox/utils/tss-react';

type DivButtonProps = Omit<React.HTMLAttributes<HTMLDivElement>, 'onClick'> & {
    onClick?: (event?: React.SyntheticEvent) => void;
};

export function getAccessibiltyProps({ onClick, disabled }: { onClick?: (event?: React.SyntheticEvent) => void; disabled?: boolean; }) {
    function onKeyDown(event: React.SyntheticEvent) {
        if (
            (event as React.KeyboardEvent).key === 'Enter' ||
            (event as React.KeyboardEvent).key === ' '
        ) {
            onClick?.(event);
        }
    }

    if (onClick != null && !disabled) {
        return {
            tabIndex: 0,
            role: 'button',
            onClick,
            onKeyDown
        };
    }

    return { disabled };
};

const useFocusStyles = makeStyles()((theme) => ({
    root: {
        '&:focus-visible': {
            outline: `2px solid ${theme.palette.secondary.main}`
        }
    }
}));

export const DivButton = React.forwardRef<HTMLDivElement, DivButtonProps>(({ onClick, className, ...props }, ref) => {
    const { classes, cx } = useFocusStyles();

    if (onClick == null) {
        return (
            <div
                ref={ref}
                className={className}
                {...props}
            />
        );
    }

    return (
        <div
            ref={ref}
            className={cx(classes.root, className)}
            {...getAccessibiltyProps({ onClick })}
            {...props}
        />
    );
});

DivButton.displayName = 'DivButton';